import { AitRowData, newRow } from "aic";
import { cellPreProcess } from "./cellPreProcess";

/**
 * Normalise rows and ensure defaults are set.
 *
 * @param defaultCellWidth - Default width to apply to cells
 * @param blank - Blank value used when creating rows
 * @param columnIds - Column ids to use when creating cells
 * @param rs - Optional rows to process
 * @returns Normalised row data
 */
export const rowPreProcess = <T>(
  defaultCellWidth: number,
  blank: T,
  columnIds: string[],
  rs?: AitRowData<T>[],
): AitRowData<T>[] => {
  // Return an empty row if there is nothing
  if (rs === undefined) return [newRow(defaultCellWidth, blank, 0, [])];
  // Check aitid
  return rs.map((r) => ({
    ...r,
    cells: cellPreProcess(defaultCellWidth, blank, columnIds, r.cells),
    aitid: r.aitid ?? crypto.randomUUID(),
    rowRepeat: undefined,
  }));
};
